/**
 * Current seasonal chapter — edit each season.
 *
 * Every product page reads from this module so the chapter, edition, and
 * dispatch window can be updated in one place. Per-slug overrides allow
 * individual bottles to ship in a different window if needed.
 */

export type ChapterInfo = {
  chapter: string;
  edition: string;
  dispatch: string;
  status: string;
};

export const CURRENT_CHAPTER: ChapterInfo = {
  chapter: "Fall 2026",
  edition: "First Edition",
  dispatch: "Third week of September",
  status: "Open for pre-order — Limited seasonal availability",
};

const PRODUCT_OVERRIDES: Record<string, Partial<ChapterInfo>> = {
  // Example: "the-archivist": { edition: "Second Edition" },
};

export function getChapterFor(slug: string): ChapterInfo {
  return { ...CURRENT_CHAPTER, ...(PRODUCT_OVERRIDES[slug] ?? {}) };
}

/**
 * Fragrances available in the current chapter, used by the Chapter Vials
 * picker. Update each season — names should match the visible product titles.
 */
export const CURRENT_CHAPTER_FRAGRANCES = [
  "The Archivist",
  "A Gentle Madness",
  "Velvet Sugar",
  "Still",
  "Hidden",
] as const;

/** Shopify handle for the Chapter Vials product (one product, three variants). */
export const CHAPTER_VIALS_HANDLE = "chapter-vials";
